export const START_LOADING = "START_LOADING";
export const FINISH_LOADING = "FINISH_LOADING";
export const CURRENT_ENTER = "CURRENT_ENTER ";
export const HEADER_STATUS = "HEADER_STATUS";
export const ROLE_ID = "ROLE_ID";
export const SET_ENTRA_MENUS = "SET_ENTRA_MENUS";
